import api from './api';

export interface GroupMember {
  id: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  role: 'super_user' | 'site_admin' | 'end_user';
}

export interface Group {
  id: string;
  siteId: string;
  name: string;
  pin: string;
  controllerUserPreset: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface GroupResponse extends Group {
  members: GroupMember[];
  controllerUserPresetName?: string | null;
}

export interface CreateGroupData {
  siteId: string;
  name: string;
  pin: string;
  userIds?: string[];
  presetIds?: string[];
  presetAliases?: Record<string, string | null>;
  controllerUserPreset?: string;
}

export interface UpdateGroupData {
  name?: string;
  pin?: string;
  userIds?: string[];
  presetIds?: string[];
  presetAliases?: Record<string, string | null>;
  controllerUserPreset?: string | null;
}

export interface GroupFilter {
  includeDeleted?: boolean;
  siteId?: string;
  name?: string;
}

export const groupsApi = {
  getAll: async (): Promise<GroupResponse[]> => {
    const { data } = await api.get('/groups');
    return data;
  },

  getBySite: async (siteId: string): Promise<GroupResponse[]> => {
    const { data } = await api.get('/groups', { params: { siteId } });
    return data;
  },

  getWithFilter: async (filter: GroupFilter): Promise<GroupResponse[]> => {
    const { data } = await api.get('/groups', { params: filter });
    return data;
  },

  getById: async (id: string): Promise<GroupResponse> => {
    const { data } = await api.get(`/groups/${id}`);
    return data;
  },

  create: async (payload: CreateGroupData): Promise<GroupResponse> => {
    const { data } = await api.post('/groups', payload);
    return data;
  },

  update: async (id: string, payload: UpdateGroupData): Promise<GroupResponse> => {
    const { data } = await api.put(`/groups/${id}`, payload);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/groups/${id}`);
  },

  addUser: async (groupId: string, userId: string): Promise<GroupResponse> => {
    const { data } = await api.post(`/groups/${groupId}/users`, { userId });
    return data;
  },

  removeUser: async (groupId: string, userId: string): Promise<GroupResponse> => {
    const { data } = await api.delete(`/groups/${groupId}/users/${userId}`);
    return data;
  },
};
